var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import Tab from "./Tab";
import "../../../@common/styles/styles.scss";
import TabBody from "./TabBody";
import { EID_REDIRECT_URL, SELF_REG_REDIRECT_URL, } from "../../../@common/Utils/RedirectUrls";
import { getFromServerAPIWithProvidedBearerToken } from "base-ui-generic/Common/Helpers/ApiHelper";
import { useLoading } from "../Context/LoadingContext";
import "../../../@common/styles/styles.scss";
import { HELP_HUB_URL, PRIVACY_POLICY_URL, TERMS_OF_USE_URL, } from "base-ui-generic/Common/Utils/RedirectURIs";
import { GetFullLoggingInfoForLoggedInUser, GetLoggingErrorFromUnhandledException, LogException, } from "base-ui-generic/Common/Helpers/LoggingHelper";
import { appInsights } from "../../../setup/logging/loggingSetup";
function TabPanel() {
    var _this = this;
    var _a = useState(0), activeIndex = _a[0], setActiveIndex = _a[1];
    var setLoading = useLoading().setLoading;
    var changeActiveIndex = function (newActiveIndex) {
        setActiveIndex(newActiveIndex);
    };
    var onEidClick = function () { return __awaiter(_this, void 0, Promise, function () {
        var response, ex_1, errorMessage, error;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    setLoading(true);
                    return [4 /*yield*/, getFromServerAPIWithProvidedBearerToken(EID_REDIRECT_URL, (_a = process.env.REACT_APP_ONBOARDING_URL) !== null && _a !== void 0 ? _a : "", {})];
                case 1:
                    response = _b.sent();
                    window.location.href = response;
                    return [3 /*break*/, 3];
                case 2:
                    ex_1 = _b.sent();
                    setLoading(false);
                    errorMessage = GetFullLoggingInfoForLoggedInUser("Logout - uncaught exception.");
                    error = GetLoggingErrorFromUnhandledException(ex_1, errorMessage);
                    LogException(appInsights, error);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // Note[AM]: Needs to be changed when we start implementing EIDAS
    var onEidasClick = function () { return __awaiter(_this, void 0, Promise, function () {
        var response, ex_2, errorMessage, error;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    setLoading(true);
                    return [4 /*yield*/, getFromServerAPIWithProvidedBearerToken(SELF_REG_REDIRECT_URL, (_a = process.env.REACT_APP_ONBOARDING_URL) !== null && _a !== void 0 ? _a : "", {})];
                case 1:
                    response = _b.sent();
                    window.location.href = response;
                    return [3 /*break*/, 3];
                case 2:
                    ex_2 = _b.sent();
                    setLoading(false);
                    errorMessage = GetFullLoggingInfoForLoggedInUser("Logout - uncaught exception.");
                    error = GetLoggingErrorFromUnhandledException(ex_2, errorMessage);
                    LogException(appInsights, error);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onSelfRegClick = function () { return __awaiter(_this, void 0, Promise, function () {
        var response, ex_3, errorMessage, error;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    setLoading(true);
                    return [4 /*yield*/, getFromServerAPIWithProvidedBearerToken(SELF_REG_REDIRECT_URL, (_a = process.env.REACT_APP_ONBOARDING_URL) !== null && _a !== void 0 ? _a : "", {})];
                case 1:
                    response = _b.sent();
                    window.location.href = response;
                    return [3 /*break*/, 3];
                case 2:
                    ex_3 = _b.sent();
                    setLoading(false);
                    errorMessage = GetFullLoggingInfoForLoggedInUser("Logout - uncaught exception.");
                    error = GetLoggingErrorFromUnhandledException(ex_3, errorMessage);
                    LogException(appInsights, error);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", __assign({ className: "modernization-tab-panel-block" }, { children: [_jsxs("div", __assign({ className: "modernization-tab-panel" }, { children: [_jsx(Tab, { activeIndex: activeIndex, tabIndex: 0, onTabChange: changeActiveIndex, mainText: "eID", additionalText: "Maltese Citizen/Resident", dataTestId: "eid-tab" }), _jsx(Tab, { activeIndex: activeIndex, tabIndex: 2, onTabChange: changeActiveIndex, mainText: "Self-Registration", additionalText: "EU National", style: { marginLeft: "5px" }, dataTestId: "selfreg-tab" })] })), 
            // activeIndex === 1 ? (
            //     <TabBody
            //         buttonText={
            //             <span>
            //                 Sign-in via <b>eIDAS</b>
            //             </span>
            //         }
            //         onButtonClick={onEidasClick}
            //         bodyText={
            //             <>
            //                 EU National <b>not</b> holding a{" "}
            //                 <b>Maltese Residency Card</b> with an <b>eIDAS</b>{" "}
            //                 account
            //             </>
            //         }
            //         dataTestId="eidas-tab-body"
            //     />
            // ) :
            activeIndex === 2 ? (_jsx(TabBody, { buttonText: _jsxs("span", { children: ["Sign-in via ", _jsx("b", { children: "Self-Registration" })] }), onButtonClick: onSelfRegClick, bodyText: _jsxs(_Fragment, { children: ["EU National ", _jsx("b", { children: "not" }), " holding a", " ", _jsx("b", { children: "Maltese Residency Card" }), _jsx("br", {}), "(please use your Passport or ID Card)"] }), dataTestId: "selfreg-tab-body" })) : (_jsx(TabBody, { buttonText: _jsxs("span", { children: ["Sign-in via ", _jsx("b", { children: "eID" })] }), onButtonClick: onEidClick, bodyText: _jsxs(_Fragment, { children: [_jsx("b", { children: "Maltese Citizen" }), " or holding a", " ", _jsx("b", { children: "Maltese Residence Permit" })] }), dataTestId: "eid-tab-body" })), _jsxs("div", __assign({ className: "modernization-tab-footer" }, { children: ["By logging in, you agree to our", " ", _jsx("a", __assign({ href: TERMS_OF_USE_URL, className: "modernization-tab-footer-link" }, { children: "Terms of Use" })), " ", "and", " ", _jsx("a", __assign({ href: PRIVACY_POLICY_URL, className: "modernization-tab-footer-link" }, { children: "Privacy Policy" })), ". If you are having issues signing in", " ", _jsx("a", __assign({ href: HELP_HUB_URL, className: "modernization-tab-footer-link" }, { children: "click here" })), "."] }))] })));
}
export default TabPanel;
